<div class="pme-container">

  <div class="display-utils-row display-utils-center">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showErrorHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}">
        <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
      </pme-hero>
    </div>
  </div>

  <div *ngIf="!this.showErrorHero">

    <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-60">
      <div class="pme-col display-utils-gt-sm-flex-50">
        <main>
          <h2 class="serasa-color-title display-utils-hide-lt-md">{{this.heroData.title}}
          </h2>
          <p class="display-utils-hide-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>

          <div class="pme-fixed-button display-utils-row display-utils-center-center display-utils-gap-20">
            <button mat-flat-button style="background-color: #14A612; color: #FFFFFF;" (click)="this.onSubmit()"
              [disabled]="this.submitting" type="submit" class="pme-btn-lg">
              <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                <mat-spinner *ngIf="this.submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                <div>Desativar recarga garantida</div>
              </div>
            </button>
          </div>
        </main>
      </div>

      <div class="pme-col display-utils-gt-sm-flex-50">
        <aside>
          <pme-product-choice *ngIf="showData" [cardTitle]="'Meu Pacote'"
            [productName]='this.selfAttendanceData.account.wallet.automaticRecharge.product.name'
            [totalValue]="this.selfAttendanceData.account.wallet.productValue" [productNameBold]="true">
            <div class="divider"></div>
            <ul>
              <li class="display-utils-row display-utils-between-center display-utils-gap-8">
                <div>Cartão cadastrado</div>
                <div class="display-utils-row display-utils-start-center display-utils-gap-8">
                  <div class="pme-payment-icon-wrapper">
                    <div
                      class="pme-payment-icon pme-payment-icon-{{this.selfAttendanceData.creditCardData.brand.toLowerCase()}}">
                    </div>
                  </div>
                  <div class="pme-text-right">{{this.selfAttendanceData.creditCardData.getFinalNumber()}}</div>
                </div>
              </li>
            </ul>
          </pme-product-choice>

          <h2 class="serasa-color-title display-utils-only-lt-md">{{this.heroData.title}}
          </h2>
          <p class="display-utils-only-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
          <div class="returnButton display-utils-hide-lt-md">
            <mat-icon (click)="returnPage()">arrow_back</mat-icon>
            <p (click)="returnPage()">Voltar</p>
          </div>
        </aside>
      </div>
    </div>

  </div>
</div>